import { render, staticRenderFns } from "./DeviceWindow2Live.vue?vue&type=template&id=233af72a&scoped=true"
import script from "./DeviceWindow2Live.vue?vue&type=script&lang=js"
export * from "./DeviceWindow2Live.vue?vue&type=script&lang=js"
import style0 from "./DeviceWindow2Live.vue?vue&type=style&index=0&id=233af72a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233af72a",
  null
  
)

export default component.exports